import React from 'react';
import { useFormikContext } from 'formik';
import { observer } from 'mobx-react';

import { useDisabledState } from 'common/disabled-context';
import { SchedulePP } from '../schedule-pp';
import { HomeCoverage, Additionals } from './coverages';
import { Umbrella } from '../umbrella';
import Detail from './detail';

function HomeOffer() {
  const { disabled } = useDisabledState();
  const { values } = useFormikContext();
  const {
    homeCoverage: { coverageX, coverageCPctOfA, coverageA },
    home: {
      homeLocation: { state }
    }
  } = values;

  const sppLimits = {
    tenPctOfCoverageC: coverageA * (coverageCPctOfA / 100) * 0.1,
    fiftyPctOfCoverageC: coverageA * (coverageCPctOfA / 100) * 0.5
  };

  return (
    <>
      <Detail disabled={disabled} />
      <SchedulePP disabled={disabled} sppLimits={sppLimits} />
      <HomeCoverage disabled={disabled} />
      <Umbrella disabled={disabled} state={state} coverageX={coverageX} />
      <Additionals disabled={disabled} />
    </>
  );
}

export default observer(HomeOffer);
